import { Breadcrumbs, EmptyState, RBButton, RbStepper } from '@scmlatam/web-ui';
import { useStepper } from '../hooks/useStepper';

const Stepper = () => {
    const stepperProps = useStepper();

    return (
        <div className="grid w-full gap-5">
            <Breadcrumbs queryKeys={['module', 'view']} className="w-full" />

            {!stepperProps.canViewCatalog && <EmptyState variant="no-permission" context="page" permissions={stepperProps.requiredCatalogPermissions.map((permission) => permission.permission)} />}

            {stepperProps.canViewCatalog && <>
                <div
                    className="bg-white w-full rounded-xl"
                    style={{
                        padding: '20px',
                        gap: '32px',
                        display: 'flex',
                        flexDirection: 'column',
                        borderRadius: '20px',
                    }}
                >
                    <RbStepper
                        activeStep={stepperProps.activeStep}
                        onStepChange={stepperProps.setActiveStep}
                        steps={[{ label: stepperProps.t('step1.title') }, { label: stepperProps.t('step2.title') }, { label: stepperProps.t('step3.title') }, { label: stepperProps.t('step4.title') }]}
                    />

                    {stepperProps.showStepContent(stepperProps.activeStep, stepperProps)}

                    <div className="flex justify-between gap-4">
                        <RBButton onClick={() => stepperProps.setActiveStep(stepperProps.activeStep - 1)} disabled={stepperProps.activeStep === 0} size="m" variant="secondary">
                            {stepperProps.t(`step${stepperProps.activeStep + 1}.buttons.previous`)}
                        </RBButton>

                        {stepperProps.activeStep !== 3 || stepperProps.canExecuteReport ? <RBButton onClick={() => stepperProps.nextStep()} disabled={stepperProps.disableNextStep()} size="m" variant="primary">
                            {stepperProps.activeStep !== 3
                                ? stepperProps.t(`step${stepperProps.activeStep + 1}.buttons.next`)
                                : stepperProps.t(`step${stepperProps.activeStep + 1}.buttons.generate_report`)}
                        </RBButton> : null}
                    </div>
                </div>
            </>}
        </div>
    );
};

export { Stepper };
